import React, { useContext } from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react/hooks';
import { Link } from 'react-router-dom';
import { toGlobalId } from 'graphql-relay';

import query, { ThreadCategoryCatalogQuery } from './thread-category-catalog.graphql';
import defaultStyles from './thread-category-catalog.scss';
import { SiteContext } from 'four-nets';

export interface Props {
    styles: typeof defaultStyles;
    threadCategoryId: string;
}

const ThreadCategoryCatalog: React.FC<Props> = React.memo(props => {
    const { styles, threadCategoryId } = props;
    const site = useContext(SiteContext);

    if (!threadCategoryId) {
        return null;
    }

    const { data } = useQuery<ThreadCategoryCatalogQuery>(query, {
        variables: { threadCategoryId: toGlobalId('ThreadCategoryNode', threadCategoryId) },
    });

    if (site.isWedding) {
        return data &&
            data.threadCatalogCategories &&
            data.threadCatalogCategories.edges &&
            data.threadCatalogCategories.edges[0] ? (
            <tr className={styles.row + ' w-full'}>
                {site.isSlovak ? (
                    <td colSpan={5} className='text-pink-700'>
                        Odporúčame dopytovač: Zadaj dopyt a{' '}
                        <a
                            href='/dopytovac'
                            className='text-pink-700 font-bold underline'
                        >
                            nájdi svojho Profesionála
                        </a>
                    </td>
                ) : (
                    <td colSpan={5} className='text-pink-700'>
                        Doporučujeme poptávač: Zadej poptávku a{' '}
                        <a
                            href='/poptavac'
                            className='text-pink-700 font-bold underline'
                        >
                            najdi svého Profesionála
                        </a>
                    </td>
                )}

                <td />
                <td />
                <td />
            </tr>
        ) : null;
    }

    return data &&
        data.threadCatalogCategories &&
        data.threadCatalogCategories.edges &&
        data.threadCatalogCategories.edges[0] ? (
        <tr className={styles.row}>
            <td>
                <FormattedMessage id='THREAD_CATEGORY_PAIRED_CATALOG_CATEGORY'>
                    {msg => (
                        <>
                            {msg}{' '}
                            <Link
                                to={`/catalog/category/${data!.threadCatalogCategories!.edges[0]!.node!.slug}/`}
                                className={styles.link}
                            >
                                {data!.threadCatalogCategories!.edges[0]!.node!.name}
                            </Link>
                        </>
                    )}
                </FormattedMessage>
            </td>
        </tr>
    ) : null;
});

export default Styled(defaultStyles)(ThreadCategoryCatalog);
